import { useNavigate } from "@tanstack/react-router";
import { Button } from "@/deps/ui-library";
import type { PlanFeature } from "@/app/plan";
import { EmptyState } from "@/components/EmptyState";

/** A part of the app this company's plan doesn't include: what it does, and which plan has it. */
export function LockedFeaturePage({ feature }: { feature: PlanFeature }) {
  const navigate = useNavigate();
  return (
    <EmptyState
      icon="Lock"
      title={`${feature.plan} includes ${feature.name.toLowerCase()}`}
      description={feature.description}
      action={
        <Button
          colorScheme="primary"
          variant="secondary"
          size="sm"
          onClick={() => void navigate({ to: "/settings/subscription" })}
        >
          View plans
        </Button>
      }
    />
  );
}
